import http from "../../api/axios";

class IssueTypesService {
  getData = (): Promise<any> => http.get("/issuetypes");
}

export default IssueTypesService;
